import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { InspectionEquipmentService } from '../../../service/inspection-equipment/inspection-equipment.service';
import { InspectionEquipment } from '../../../class/inspection-equipment';

@Component({
  selector: 'app-inspection-equipment',
  templateUrl: './inspection-equipment.component.html',
  styleUrls: ['./inspection-equipment.component.scss']
})
export class InspectionEquipmentComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoInspectionEquipment: InspectionEquipment;
    public department: InspectionEquipment;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public departmentService: InspectionEquipmentService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelInspectionEquipment () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/inspection-equipments/inspection-equipment/inspection-equipment.component.ts